import emailjs from '@emailjs/browser';
import { logger } from '../utils/logger';

/**
 * EmailJS Service Integration
 * 
 * Configuration:
 * - Service ID: service_0aazm5k
 * - Template ID: template_7rylxmn
 * - Public Key: ua6KOAc6_Hsqh0EP_
 * 
 * Recipients: puzza001@gmail.com, simran@simplprocessing.com
 * 
 * This service handles sending quote request emails and notifications
 * via EmailJS when customers submit the contact form.
 */

// EmailJS configuration
const EMAILJS_SERVICE_ID = 'service_0aazm5k';
const EMAILJS_TEMPLATE_ID = 'template_7rylxmn';
const EMAILJS_PUBLIC_KEY = 'ua6KOAc6_Hsqh0EP_';

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY);

export interface EmailTemplateParams extends Record<string, unknown> {
  to_email?: string; // Optional - should be configured in EmailJS service settings
  from_name: string;
  from_email: string;
  phone?: string;
  business_name?: string;
  business_address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  business_type?: string;
  years_in_business?: string;
  monthly_volume?: string;
  annual_revenue?: string;
  current_processor?: string;
  system_type?: string;
  additional_needs?: string;
  timeline?: string;
  message?: string;
  debug_info?: string;
  lead_score?: number;
  qualified?: string;
}

export const sendQuoteRequestEmail = async (params: EmailTemplateParams): Promise<void> => {
  try {
    logger.log('📧 Sending quote request email via EmailJS...');
    logger.log('📧 Service ID:', EMAILJS_SERVICE_ID);
    logger.log('📧 Template ID:', EMAILJS_TEMPLATE_ID);
    logger.log('📧 Parameters being sent:', JSON.stringify(params, null, 2));
    
    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      params
    );
    
    logger.log('✅ Email sent successfully:', result.text);
    logger.log('✅ EmailJS Response:', result);
  } catch (error) {
    logger.error('❌ Error sending email:', error);
    throw error;
  }
};

export const sendNotificationEmail = async (
  toEmail: string,
  subject: string,
  message: string,
  fromName: string = 'Simpl Processing'
): Promise<void> => {
  try {
    logger.log('📧 Sending notification email via EmailJS...');
    
    const params = {
      to_email: toEmail,
      from_name: fromName,
      subject: subject,
      message: message
    };
    
    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      params
    );
    
    logger.log('✅ Notification email sent successfully:', result.text);
  } catch (error) {
    logger.error('❌ Error sending notification email:', error);
    throw error;
  }
};

const emailService = {
  sendQuoteRequestEmail,
  sendNotificationEmail
};

export default emailService;
